import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
// Shared styles that must be present before ANY route renders.
// These contain classes used across multiple lazy-loaded chunks (e.g. .layout-banner-*,
// .about-us, .banner).  Loading them here — in the main bundle — guarantees
// they are injected synchronously, so no route ever renders with missing styles.
// index.scss is imported first to establish CSS custom properties (:root vars)
// that the layout/component styles below depend on.
import "styles/global.scss";
import App from "./components/app/App";
import reportWebVitals from "./reportWebVitals";
import Wrapper from "components/app/Wrapper";
import '@fortawesome/fontawesome-free/css/fontawesome.min.css';
import '@fortawesome/fontawesome-free/css/solid.min.css';
import '@fortawesome/fontawesome-free/css/regular.min.css';
import '@fortawesome/fontawesome-free/css/brands.min.css';
import { initializeApp } from "firebase/app";
import { getPerformance } from "firebase/performance";
import { getAnalytics } from "firebase/analytics";

const {
  REACT_APP_FIREBASE_API_KEY,
  REACT_APP_AUTH_DOMAIN,
  REACT_APP_PROJECT_ID,
  REACT_APP_STORAGE_BUCKET,
  REACT_APP_MESSAGING_SENDER_ID,
  REACT_APP_APP_ID,
  REACT_APP_MEASUREMENT_ID,
} = process.env;

export const firebaseConfig = {
  apiKey: REACT_APP_FIREBASE_API_KEY,
  authDomain: REACT_APP_AUTH_DOMAIN,
  projectId: REACT_APP_PROJECT_ID,
  storageBucket: REACT_APP_STORAGE_BUCKET,
  messagingSenderId: REACT_APP_MESSAGING_SENDER_ID,
  appId: REACT_APP_APP_ID,
  measurementId: REACT_APP_MEASUREMENT_ID,
};

ReactDOM.render(
  <React.StrictMode>
    <Wrapper>
      <App />
    </Wrapper>
  </React.StrictMode>,
  document.getElementById("root"),
  () => {
    // Defer Firebase initialization and its observability services until after
    // the first render is committed to the DOM. Neither initializeApp nor the
    // Performance/Analytics services are needed for rendering or auth — they
    // are purely observability tools. Deferring them removes synchronous boot
    // path overhead, allowing React to paint the initial UI before Firebase
    // initialization runs. requestIdleCallback (Chrome/Edge) or setTimeout(0)
    // (Safari/Firefox) ensures initialization completes after first paint.
    const app = initializeApp(firebaseConfig);
    const initFirebaseServices = () => {
      getPerformance(app);
      getAnalytics(app);
    };
    if ("requestIdleCallback" in window) {
      (window as any).requestIdleCallback(initFirebaseServices);
    } else {
      setTimeout(initFirebaseServices, 0);
    }
  }
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
